import { PUBLIC_APP_ENV, PUBLIC_SANITY_API_READ_TOKEN } from '$env/static/public';
import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// TODO: Extract to .env
const SANITY_PROJECT_ID = '0u2q0huj';
const SANITY_DATASET = 'production';
const SANITY_API_VERSION = '2024-12-03';

const previewMode = PUBLIC_APP_ENV !== 'prod';
if (previewMode && !PUBLIC_SANITY_API_READ_TOKEN) {
	console.warn(
		'To use the preview mode of sanity make sure to set the PUBLIC_SANITY_API_READ_TOKEN env var'
	);
}

// TODO: Move Sanity client to BE endpoint (proxy/cache)
export const sanityWebsiteClient = createClient({
	projectId: SANITY_PROJECT_ID,
	dataset: SANITY_DATASET,
	apiVersion: SANITY_API_VERSION,
	token: PUBLIC_SANITY_API_READ_TOKEN,
	useCdn: !previewMode,
	perspective: previewMode ? 'drafts' : 'published',
	ignoreBrowserTokenWarning: true
});
const urlBuilder = imageUrlBuilder(sanityWebsiteClient);

export function assetBuilder(assetId: string) {
	return urlBuilder.image(assetId).auto('format');
}

export type ImageDimensions = { width?: number; height?: number };

export function buildImageUrl(assetId: string, { width, height }: ImageDimensions): string {
	let builder = assetBuilder(assetId);

	if (width) {
		builder = builder.width(width);
	}

	if (height) {
		builder = builder.height(height);
	}

	return builder.url();
}
